module.exports = __webpack_public_path__ + "static/js/refresh.737c18b8.chunk.worker.js"